export const Colors = {
    black: 'black',
    blue: 'blue',
    darkBlue: 'dark_blue',
    lightBlue: 'light_blue',
    brown: 'brown',
    gray: 'gray',
    darkGreen: 'dark_green',
    green: 'green',
    limeGreen: 'lime_green',
    orange: 'orange',
    pink: 'pink',
    purple: 'purple',
    brightRed: 'bright_red',
    red: 'red',
    teal: 'teal',
    white: 'white',
    brightYellow: 'bright_yellow',
    yellow: 'yellow'
}